import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import { InvitationSection, VerseSection } from "@/components/Story";
import PhotoSection from "@/components/PhotoSection";
import Countdown from "@/components/Countdown";
import Details from "@/components/Details";
import Menu from "@/components/Menu";
import RSVPForm from "@/components/RSVPForm";
import Footer from "@/components/Footer";
import MusicPlayer from "@/components/MusicPlayer";
import FallingLeaves from "@/components/FallingLeaves";

const WeddingHome = () => {
  return (
    <main data-testid="wedding-home" className="overflow-x-hidden relative">
      <FallingLeaves count={6} />
      <Header />
      <Hero />
      <InvitationSection />
      <PhotoSection />
      <VerseSection />
      <Countdown />
      <Details />
      <Menu />
      <RSVPForm />
      <Footer />
      <MusicPlayer />
    </main>
  );
};

export default WeddingHome;
